<template>
  <div class="bg-white px-3 index" :style="'height:'+heights">
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="分会介绍">
        <el-input type="textarea" v-model="form.desc" style="max-width: 800px" :rows="10" size="small"></el-input>
      </el-form-item>
      <el-form-item label="协会新闻">
        <el-button type="primary" size="mini" @click="visble(2,'协会新闻')">设置</el-button>
      </el-form-item>
      <el-form-item label="协会事件">
        <el-button type="primary" size="mini" @click="visble(3,'协会事件')">设置</el-button>
      </el-form-item>
      <el-form-item label="政策解读">
        <el-button type="primary" size="mini" @click="visble(4,'政策解读')">设置</el-button>
      </el-form-item>
      <el-form-item label="科普宣教">
        <el-button type="primary" size="mini" @click="visble(5,'科普宣教')">设置</el-button>
      </el-form-item>

    </el-form>
    <div class="btns_b">
      <el-button type="success" @click="waisubmit" :loading='submitloading'>提交设置</el-button>
    </div>
    <el-dialog :title="`${setTitle}设置`" :visible.sync="dialogVisible" center top="20px" width="70%" class="dialogs" @close="clear">
      <el-divider></el-divider>
      <div class="dialog-ibox-content" v-loading="openeditloading">
        <el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="150px" class="demo-ruleForm forms-lines">
          <el-form-item label="标题" prop="lb_title">
            <el-input v-model="ruleForm.lb_title" size="small"></el-input>
          </el-form-item>
          <el-form-item label="封面" required>
            <el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload"
              :headers="{ token: $store.state.user.token }" :data="{
                image_class_id: '72',
                file_type: '1',
              
              }" :file-list="ruleForm.lb_mapList" :on-success="uploadSuccess" :on-remove="uploadRmove"
              list-type="picture-card">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="描述">
            <div class="u-f u-ac">
              <el-input v-model="ruleForm.describe" type="textarea" :rows="3" size="small" placeholder="文章描述">
              </el-input>
            </div>
          </el-form-item>

          <el-form-item label="内容" prop="lb_content">
            <tinymce ref="editor" v-model="ruleForm.lb_content"
              toolbar="undo redo |  formatselect | bold italic link| alignleft aligncenter alignright alignjustify | bullist numlist outdent indent  | removeformat | imageUpload" />
          </el-form-item>
        </el-form>
      </div>
      <el-divider></el-divider>
      <span slot="footer" class="dialog-footer">
        <el-button @click="submit('ruleForm')" size="small" type="primary" :loading="subloading">提 交</el-button>
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import tinymce from "@/components/common/tinymce.vue";
  export default {
    components: {
      tinymce,
    },
    data() {
      return {
        //分会介绍
        form: {
          desc: "",
        },
        dialogVisible: false,
        //弹框内信息
        ruleForm: {
          //标题
          lb_title: "",
          //富文本
          lb_content: "",
          //图片
          lb_mapList: [],
          //描述
          describe: "",
        },
        rule: {
          lb_title: [{
            required: true,
            message: "请填写图文标题",
            trigger: "blur",
          }, ],

          lb_content: [{
            required: true,
            message: "请填写图文内容",
            trigger: "blur",
          }, ],
        },
        subloading: false,
        openeditloading: false,
        //图片
        mapListed: [],
        num: 1,
        type: 0,
        heights: null,
        submitloading: false,
        setTitle:'',
      };
    },
    created() {
      this.visble2(1);
    },
    mounted() {
      this.getHeight()
    },
    methods: {
      // 获取高度
      getHeight() {
        let that = this;
        that.heights = window.innerHeight - 150 + 'px'
        window.onresize = () => {
          that.heights = window.innerHeight - 150 + 'px'
        }
      },
      //弹框内提交按钮
      submit(formName) {
        let that = this;
        that.$refs[formName].validate((valid) => {
          if (valid) {
            if (that.mapListed.length < 1)
              return that.$message.error("请上传图文封面");
            that.subloading = true;
            let urls = this.type == 0 ? "/admin/branch/save" : "/admin/branch/update"
            axios
              .post(
                urls, {
                  id: this.type == 0 ? '' : this.num,
                  title: that.ruleForm.lb_title,
                  image: that.mapListed[0].url,
                  content_type: that.num,
                  content: that.ruleForm.lb_content,
                  describe: that.ruleForm.describe,
                }, {
                  token: true,
                }
              )
              .then((response) => {
                that.subloading = false;
                if (response.data.code == "200") {
                  this.mapListed = [];
                  this.ruleForm.lb_mapList = [];
                  that.dialogVisible = false;
                  this.$message.success('操作成功！')
                } else {
                  that.$message.error(response.data.msg);
                }
              })
              .catch((error) => {
                that.subloading = true;
              });
          } else {
            this.$alert("信息遗漏未填");
            return false;
          }
        });
      },
      //四个设置按钮
      visble(num,tit) {
        this.setTitle=tit
        this.num = num;
        this.dialogVisible = true;
        this.openeditloading = true
        let urls = "/admin/branch/read";
        axios
          .post(
            urls, {
              id: num,
            }, {
              token: true,
            }
          )
          .then((res) => {
            this.openeditloading = false

            this.ruleForm.lb_title = res.data.data.title;
            this.ruleForm.lb_content = res.data.data.content;
            this.ruleForm.describe = res.data.data.describe;
            this.ruleForm.lb_mapList.push({
              url: res.data.data.image
            });
            this.mapListed.push({
              url: res.data.data.image
            });
            if (Object.keys(res.data.data).length !== 0) {
              this.type = 1;
            } else {
              this.type = 0;
            }
          })
          .catch((error) => {
            console.log("报错");
          });
      },
      //分会介绍数据获取
      visble2(num) {
        this.num = num;
        let urls = "/admin/branch/read";
        axios
          .post(
            urls, {
              id: num,
            }, {
              token: true,
            }
          )
          .then((res) => {
            this.form.desc = res.data.data.content;
          })
          .catch((error) => {
            console.log("报错", error);
          });
      },
      //外部提交按钮
      waisubmit() {
        this.submitloading = true
        let urls = this.form.desc == "" ? "/admin/branch/save" : "/admin/branch/update"
        axios
          .post(
            urls, {
              id: this.form.desc == "" ? '' : 1,
              title: null,
              image: null,
              content_type: 1,
              content: this.form.desc,
              describe: null,
            }, {
              token: true,
            }
          )
          .then((res) => {
            this.submitloading = false
            if (res.data.code == 200) {
              this.$message.success('提交成功！')
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch((error) => {
            that.subloading = true;
          });
      },
      //删除图片
      uploadRmove(file, fileList) {
        var index = this.mapListed.findIndex((item) => item.id == file.id);
        this.mapListed.splice(index, 1);
      },
      //上传成功
      uploadSuccess(response, file, fileList) {
        let that = this;
        if (response.code == "201") {
          that.$nextTick(() => {
            let mainImg = that.$refs.upload;
            if (mainImg) {
              mainImg.uploadFiles.forEach((element, index) => {
                if (file.uid == element.uid) {
                  mainImg.uploadFiles.splice(index, 1);
                }
              });
            }
          });
          that.$alert(response.msg);
          return;
        }
        that.$message({
          message: "上传成功",
          type: "success",
        });
        that.mapListed.push(response.data);
      
      },
      //关闭弹框
      clear() {
        this.mapListed = [];
        this.ruleForm.lb_mapList = [];
      },
    },
  };
</script>

<style lang="scss" scoped>
  .index {
    padding: 20px 0;

    .btns_b {
      display: flex;
      justify-content: flex-end;
      max-width: 880px;
    }
  }
</style>